<template>
  <g class="Grid" :transform="`translate(${left}, ${top})`">
    <g class="Grid-axes" v-if="axes">
      <g
        v-for="(axis, i) in axes"
        class="Grid-axis"
        :key="i"
        :transform="`translate(${axis.xPos}, ${axis.yPos})`"
      >
        <datalas-axis
          v-bind="axis.props"
          @update:axisTickSize="$emit('update:axisTickSize', $event)"
          @update:axisSize="$emit('update:axisSize', $event)"
        />
      </g>
    </g>
  </g>
</template>

<script>
export default {
  name: 'DatalasGrid',

  emits: ['update:axisTickSize', 'update:axisSize'],

  props: {
    axes: {
      type: Array,
    },
    top: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
  },
};
</script>
